import * as React from "react";
import { Row, Col, Input } from "antd";
import EqButton from "../../custom/eqButton/EqButton";
import {
    ApiEndpoints,
    GetEventMessage,
    openNotificationWithIcon,
    ValidateIsTrainer,
    ValidateIsUser,
} from "../../shared/Common";
import Api from "../../shared/Api";
import "./EqOwnerProductsBoard.scss";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "../../context/Context";
import {
    eqNotificationTypes,
    ProductOrderStatus,
    ProductStatus,
    ProductType,
} from "../../shared/enums";
import EqCollapsePanel from "../../custom/eqCollapsePanel/EqCollapsePanel";
import EqToggle, { IEqToggle } from "../../custom/eqToggle/EqToggle";
import EqProductList, { IEqProductList } from "../../custom/eqProductList/EqProductList";
import { EqProductsBoardOrderList } from "../../custom/eqProductsBoardOrderList/EqProductsBoardOrderList";
import EditorCreateProduct from "../../custom/editorCreateProduct/EditorCreateProduct";
import AnimationDiv from "../../custom/animationDiv/AnimationDiv";
import RevealList from "../../custom/RevealList/RevealList";
import EqSelect from "../../custom/eqSelect/EqSelect";
import { ISelectProps } from "../../shared/Interfaces";
import { IProductOPtions } from "../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto";
import { IStudentGroupDto } from "../../shared/interfaces/IStudentGroupDto";
import { UserAndGroupOptionDto } from "../../shared/interfaces/IUserInfoDto";
import { EqEntityProductDto, EqProductType, IProductsList } from "../../shared/interfaces/IProduct";
import { Drawer, Tabs } from "antd-v5";
import EqProductRequests from "../../custom/EqProductRequests/EqProductRequests";
import RequestWidget from "../../custom/EqProductRequests/RequestWidget/RequestWidget";
import EqProductInvitations from "../../custom/EqProductInvitations/EqProductInvitations";
import { CloseOutlined } from "@ant-design/icons";
import ProductInviteWidget from "../../custom/ProductInviteWidget/ProductInviteWidget";

export interface IFilteredTrainings {
    name: any;
    type: any;
    date: any;
}

const EqOwnerProductsBoard = (props: any) => {
    const { Search } = Input;
    const userDetails: any = useAuthState();
    const isUserValid: boolean = ValidateIsUser(userDetails);
    const isTrainer: boolean = ValidateIsTrainer(userDetails);
    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [message, setMessage] = React.useState("");
    const [isError, setIsError] = React.useState(false);

    const [studentsList, setStudentsList] = React.useState<Array<IStudentGroupDto>>([]);
    const [addNew, setAddNew] = React.useState(false);
    const [isEdit, setIsEdit] = React.useState(false);
    const [selectedProduct, setSelectedProduct] = React.useState(null) as any;
    const [schoolStudentsAndGroups, setSchoolStudentsAndGroups] = React.useState<
        UserAndGroupOptionDto[]
    >([]);

    const [studentsName, setStudentsName] = React.useState("");
    const [search, setSearch] = React.useState({
        searchVal: "",
    });

    const [selectedProducts, setSelectedProducts] = React.useState([] as any);
    const [productOptions, setProductOptions] = React.useState<IProductOPtions>();

    const [selectedProductType, setSelectedProductType] = React.useState([] as any);
    const [productTypeOption, setProductTypeOption] = React.useState([] as any);

    // const [showEventList, setShowEventList] = React.useState(true);
    // const [createActivityList, setCreateActivityList] = React.useState([] as Array<any>);

    const [productsList, setProductsList] = React.useState<IProductsList>({
        all: [],
        filteredList: [],
        private: [],
        public: [],
    }) as any;
    const [productListToggle, setProductListToggle] = React.useState(ProductType.Private);
    const [productTypeOptions, setProductTypeOptions] = React.useState([]);

    const [activeTab, setActiveTab] = React.useState("tab1"); // Track whether we are in edit mode
    const [productRequests, setProductRequests] = React.useState<any>(null);
    const [productInvites, setProductInvites] = React.useState<any>(null);

    // GetSchoolStudents();

    // Toggle Filters
    const createProductTypeOptions = () => {
        var types = [] as any;
        for (var x in ProductType) {
            if (isNaN(Number(x)) == false) {
                types.push({ key: Number(x), value: ProductType[x] });
            }
        }
        setProductTypeOptions(types);
    };

    const GetSchoolStudentsAndGroupsAsOptions = async () => {
        try {
            let apiPath = ApiEndpoints.School.GetSchoolStudentsAndGroupsAsOptions;
            if(isTrainer){
                apiPath= ApiEndpoints.Trainer.GetTrainerStudentsAndGroupsAsOptions
            }
            const response = await Api.get(apiPath);
            if (response && response.status === 200) {
                setSchoolStudentsAndGroups(response.data);
            } else {
                setMessage(GetEventMessage(response.status));
            }
        } catch (error: any) {
            setIsError(true);
            setMessage(GetEventMessage(error.response.status));
        }
    };

    //Products
    const getProductList = () => {
        // let path=ApiEndpoints.UserProduct + `?unused=true`
        let path = ApiEndpoints.UserProduct;
        Api.get(path).then(
            (response) => {
                if (response && response.status == 200) {
                    setIsError(false);
                    setMessage("");

                    // setProductList(response.data);
                    formatProductListData(response.data);
                    createProductList(response.data);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const formatProductListData = (data: any) => {
        var privateList = data?.filter((opt: any) => opt.type == ProductType.Private);
        var publicList = data?.filter((opt: any) => opt.type == ProductType.Public);

        var productList = {
            all: [...data],
            filteredList: [...data],
            private: [...privateList],
            public: [...publicList],
        };
        setProductsList({ ...productList });
    };

    const handleOnProductSend = (data: any) => {
        const list = [...productsList.all];
        var foundIndex = list.findIndex((x) => x.id == data[0].product.id);
        list[foundIndex].productOrders.push(data);

        formatProductListData(list);
    };
    const removeProduct = (data: any) => {
        Api.delete(ApiEndpoints.UserProduct + `/${data.id}`).then(
            (response) => {
                if (response && response.status == 200) {
                    removeItem(data);
                } else {
                    setIsError(true);
                    // setErrorMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                // setErrorMessage(GetEventMessage(error.response.status));
            }
        );
    };
    const removeItem = (data: any) => {
        if (productsList.all != undefined) {
            var updatedList =
                productsList.all != undefined
                    ? productsList.all.filter((item: any) => item.id !== data.id)
                    : new Array<any>();
            // setProductList(updatedList);
            formatProductListData(updatedList);
            // horsesList.map((item: any, index: number) => {
            //   item.display = index == 0 ? true : false;
            // });
        }
    };

    const showAddNew = () => {
        setSelectedProduct(null);
        setProductRequests(null);
        setProductInvites(null);

        setAddNew(true);
    };

    const handleOnCreate = (data: any, isPublishDraft = false, draftId?: string) => {
        const updatedProducts = [...productsList.all];
        if (isPublishDraft) {
            // Replace the draft in the list with the published course
            const draftIndex = updatedProducts.findIndex((p) => p.id === draftId);
            if (draftIndex !== -1) {
                updatedProducts[draftIndex] = data;
            }
        } else {
            if (data.status === ProductStatus.Drafted) {
                const draftIndex = updatedProducts.findIndex(
                    (p) => p.status === ProductStatus.Drafted
                );
                if (draftIndex !== -1) {
                    updatedProducts[draftIndex] = data;
                } else {
                    // If no draft exists, just add the new event af first place

                    updatedProducts.push(data);
                }
            } else {
                updatedProducts.push(data);
            }
        }
        formatProductListData(updatedProducts);

        cancelFunc();
    };

    const cancelFunc = () => {
        setSelectedProduct();
        setAddNew(false);
    };

    const editProduct = (data: any) => {
        setSelectedProduct(data);

        // Add `product` to each request
        const productRequests = data?.productOrders
            ?.filter((order:any) => order.status === ProductOrderStatus.Requested)
            ?.map((order:any) => ({ ...order, product: data }));

        if (productRequests?.length) {
            setProductRequests(productRequests);
        }

        // const productInvitations = data?.productOrders
        //     ?.filter(invite => invite.status === ProductOrderStatus.Pending);

        const productInvitations = data?.productOrders
            ?.filter((order:any) => order.status === ProductOrderStatus.Pending)
            ?.map((order:any) => ({ ...order, product: data }));

        if (productInvitations?.length) {
            setProductInvites(productInvitations);
        }
        
        setIsEdit(true);
    };

    const handleOnEdit = (data: any) => {
        const list = [...productsList.all];
        var foundIndex = list.findIndex((x) => x.id === data.id);
        list[foundIndex] = data;

        formatProductListData(list);
        setIsEdit(false);
    };
    const cancelEdit = () => {
        setIsEdit(false);
    };

    //filter
    const filterProductsOrders = (productList: any[]) => {
        let filteredList = productList;

        if (studentsName && studentsName.length > 0) {
            const searchName = studentsName.toLowerCase();
            //name
            filteredList = productList.map((item) => {
                const productOrders = item?.productOrders;

                const filteredProductOrders = productOrders.filter((productOrder: any) => {
                    const firstName_Pro = productOrder?.student?.firstName;
                    const lastName_Pro = productOrder?.student?.lastName;
                    const username_Pro = productOrder?.student?.email;

                    return (
                        (firstName_Pro &&
                            (firstName_Pro + " " + lastName_Pro)
                                .toLowerCase()
                                .includes(searchName)) ||
                        (username_Pro && username_Pro.toLowerCase().includes(searchName))
                    );
                });

                return {
                    ...item,
                    productOrders: filteredProductOrders,
                };
            });
        }

        //Product
        if (selectedProducts && selectedProducts.length > 0) {
            filteredList = filteredList.filter((item) => {
                return selectedProducts.includes(item?.title + "");
            });
        }

        //Type
        // if (selectedProductType && selectedProductType.length > 0) {
        //   filteredList = filteredList.filter((item) => {

        //     return selectedProductType.includes(item?.type + "")

        //   }
        //   );
        // }
        if (selectedProductType && selectedProductType.length > 0) {
            filteredList = filteredList.filter((item) => {
                return selectedProductType.some((selectedType: any) => item?.type === selectedType);
            });
        }

        console.log("filteredList:", filteredList);
        return filteredList;
    };

    const filterSelectedProductOrders = (productList: any[]) => {
        if (!selectedProduct?.id?.length) return;

        let filteredList = productList.filter((d) => d.id === selectedProduct.id);

        if (studentsName && studentsName.length > 0) {
            const searchName = studentsName.toLowerCase();
            //name
            filteredList = productList.map((item) => {
                const productOrders = item?.productOrders;

                const filteredProductOrders = productOrders.filter((productOrder: any) => {
                    const firstName_Pro = productOrder?.student?.firstName;
                    const lastName_Pro = productOrder?.student?.lastName;
                    const username_Pro = productOrder?.student?.email;

                    return (
                        (firstName_Pro &&
                            (firstName_Pro + " " + lastName_Pro)
                                .toLowerCase()
                                .includes(searchName)) ||
                        (username_Pro && username_Pro.toLowerCase().includes(searchName))
                    );
                });

                return {
                    ...item,
                    productOrders: filteredProductOrders,
                };
            });
        }

        //Product
        if (selectedProducts && selectedProducts.length > 0) {
            filteredList = filteredList.filter((item) => {
                return selectedProducts.includes(item?.title + "");
            });
        }

        if (selectedProductType && selectedProductType.length > 0) {
            filteredList = filteredList.filter((item) => {
                return selectedProductType.some((selectedType: any) => item?.type === selectedType);
            });
        }

        console.log("filteredList:", filteredList);
        return filteredList;
    };

    const searchNameClick = (searchStr: string) => {
        setSearch({ ...search, searchVal: searchStr });
        setStudentsName(searchStr);

        const filteredProducts = filterProductsOrders(productsList.all);
        setProductsList({ ...productsList, filteredList: filteredProducts });
    };

    const createProductList = (items: any[]) => {
        const productTitlesMap = new Map();
        items.forEach((item) => {
            const productTitle = item?.title;
            if (productTitle) {
                productTitlesMap.set(productTitle, {
                    key: productTitle,
                    value: productTitle,
                    label: productTitle,
                });
            }
        });
        const uniqueProductTitles: any = Array.from(productTitlesMap.values());

        setProductOptions(uniqueProductTitles);
    };

    const productProps: ISelectProps = {
        classNames: `eq-multiSelect eq-searchSelect`,
        placeholder: t("product"),
        mode: "multiple",
        isTag: false,
        defaultSelectedValue: selectedProducts ? selectedProducts : [],
        options: productOptions,
        changeFunc: (value: any) => {
            console.log(value);

            setSelectedProducts(value);
        },
    };
    const createProductTypeList = () => {
        var productTypes = [];
        productTypes.push({
            key: ProductType.Public,
            value: t(ProductType[ProductType.Public]),
        });
        productTypes.push({
            key: ProductType.Private,
            value: t(ProductType[ProductType.Private]),
        });

        setProductTypeOption(productTypes);
        console.log("options", productOptions);
    };

    const productTypeProps: ISelectProps = {
        classNames: `eq-multiSelect eq-searchSelect`,
        placeholder: t("selectProductType"),
        mode: "multiple",
        isTag: false,
        defaultSelectedValue: selectedProductType ? selectedProductType : [],
        options: productTypeOption,
        changeFunc: (value: any) => {
            console.log(value);

            setSelectedProductType(value);
        },
    };

    React.useEffect(() => {
        createProductTypeOptions();
        GetSchoolStudentsAndGroupsAsOptions();
        getProductList();
        createProductTypeList();
        // GetSchoolStudents();

        window.scrollTo(0, 0);
    }, []);

    const onProductDrawerClose = (): void => {
        setIsEdit(false);
        setAddNew(false);
    };

    const handleAcceptProductRequest = async (requestId: string, price: number | null) => {
        try {
            const response = await Api.put(
                `${ApiEndpoints.UserProductRequest.Accept}/${requestId}`,
                { price }
            );
            if (response.status === 200) {
                setProductRequests((prevRequests: any) =>
                    prevRequests.filter((invite: any) => invite.id !== requestId)
                );

                openNotificationWithIcon(
                    "Accepted!",
                    "Successfully Accepted Request",
                    eqNotificationTypes.success
                );
            } else {
                console.error("Unexpected response status:", response.status);
            }
        } catch (error: any) {
            if (error.response.status === 409) {
                openNotificationWithIcon(
                    "Error!",
                    `Unable to Accept Request for ${error.response.data.product.title}`,
                    eqNotificationTypes.error
                );
            } else {
                console.error("Error Accepting invite:", error);
                openNotificationWithIcon("Error!", "Unable to Accept", eqNotificationTypes.error);
            }
        }
    };

    const handleRejectProductRequest = async (requestId: string) => {
        try {
            const response = await Api.put(
                `${ApiEndpoints.UserProductRequest.Reject}/${requestId}`
            );

            if (response.status === 200) {
                setProductRequests((prevRequests: any) =>
                    prevRequests.filter((invite: any) => invite.id !== requestId)
                );

                openNotificationWithIcon(
                    "Rejected!",
                    "Successfully Rejected Request",
                    eqNotificationTypes.success
                );
            } else {
                console.error("Unexpected response status:", response.status);
            }
        } catch (error) {
            console.error("Error Reject invite:", error);
            openNotificationWithIcon("Error!", "Unable to Reject", eqNotificationTypes.error);
        }
    };

    const handleAcceptProductMultipleRequests = async (requestIds: any) => {
        try {
            const response = await Api.put(
                ApiEndpoints.UserProductRequest.AcceptMultipleRequests,
                requestIds
            );

            if (response.status === 200) {
                // Remove deleted requestIds from the local state
                setProductRequests((prevRequests: any) =>
                    prevRequests.filter((invite: any) => !requestIds.includes(invite.id))
                );

                openNotificationWithIcon(
                    "Accepted!",
                    "successfully Accepted Requests",
                    eqNotificationTypes.success
                );
            } else {
                console.error("Unexpected response status:", response.status);
            }
        } catch (error: any) {
            if (error.response.status === 409) {
                openNotificationWithIcon(
                    "Error!",
                    `Unable to Accept Request for ${error.response.data.product.title}`,
                    eqNotificationTypes.error
                );
            } else {
                console.error("Error Accepting invite:", error);
                openNotificationWithIcon("Error!", "Unable to Accept", eqNotificationTypes.error);
            }
        }
    };

    const handleRejectProductMultipleRequests = async (requestIds: any) => {
        try {
            const response = await Api.put(
                ApiEndpoints.UserProductRequest.RejectMultipleRequests,
                requestIds
                // {
                //   data: [...requestIds] ,
                // }
            );

            if (response.status === 200) {
                // Remove deleted requestIds from the local state
                setProductRequests((prevRequests: any) =>
                    prevRequests.filter((invite: any) => !requestIds.includes(invite.id))
                );

                openNotificationWithIcon(
                    "Rejected!",
                    "successfully Rejected Requests",
                    eqNotificationTypes.success
                );
            } else {
                console.error("Unexpected response status:", response.status);
            }
        } catch (error) {
            console.error("Error deleting requests:", error);

            openNotificationWithIcon("Error!", "Unable to Reject", eqNotificationTypes.error);
        }
    };

    const handleDeleteProductInvite = async (inviteId: string) => {
        try {
            const response = await Api.delete(
                `${ApiEndpoints.UserProductInvite.DeleteInvite}/${inviteId}`
            );

            if (response.status === 200) {
                setProductInvites((prevInvites: any) =>
                    prevInvites.filter((invite: any) => invite.id !== inviteId)
                );
                openNotificationWithIcon(
                    "Deleted!",
                    "Successfully Removed Invite",
                    eqNotificationTypes.success
                );
            } else {
                console.error("Unexpected response status:", response.status);
            }
        } catch (error) {
            console.error("Error deleting invite:", error);
            openNotificationWithIcon("Error!", "Unable to Delete", eqNotificationTypes.error);
        }
    };

    const handleDeleteProductInvites = async (inviteIds: any) => {
        try {
            const response = await Api.delete(
                ApiEndpoints.UserProductInvite.DeleteMultipleInvites,
                {
                    data: [...inviteIds],
                }
            );

            if (response.status === 200) {
                // Remove deleted inviteIds from the local state
                setProductInvites((prevInvites: any) =>
                    prevInvites.filter((invite: any) => !inviteIds.includes(invite.id))
                );

                openNotificationWithIcon(
                    "Deleted!",
                    "successfully Removed Invites",
                    eqNotificationTypes.success
                );
            } else {
                console.error("Unexpected response status:", response.status);
            }
        } catch (error) {
            console.error("Error deleting invites:", error);

            openNotificationWithIcon("Error!", "Unable to Delete", eqNotificationTypes.error);
        }
    };

    return (
        <AnimationDiv>
            <div className={`eq-trainer-products-board`}>
                <div className="eq-container-fluid">
                    <Row className="eq-tp-heading-row" align="middle" justify="start">
                        <Col className="eq-tp-heading-col" flex="auto">
                            <h3 className="eq-tp-heading">{t("allProductsAndCourses")}</h3>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="gutter-row" span={24}>
                            <div className="product-type">
                                <div className="label">{t("selectProductType")}</div>
                                <span className="dis">
                                    {t("publicProductCreate")}
                                    <br />
                                    {t("privateProductCreate")}
                                </span>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="gutter-row" span={24}>
                            <div className="create-product add-btn-icon" onClick={showAddNew}>
                                <img alt="" className="add" src="/plus-black.svg" />
                            </div>
                        </Col>
                    </Row>

                    <div className="eq-section">
                        <Row>
                            {productsList.all?.length > 0 && (
                                <RevealList>
                                    <Col span={24}>
                                        <EqProductList
                                            studentsAndGroups={schoolStudentsAndGroups}
                                            productList={productsList.all}
                                            removeProduct={removeProduct}
                                            editProduct={editProduct}
                                            onProductSend={handleOnProductSend}
                                        />
                                    </Col>
                                </RevealList>
                            )}
                        </Row>
                    </div>
                    {/*Drawer*******************************************************************************************/}
                    <Drawer
                        closable={true}
                        closeIcon={
                            <EqButton
                                shape="circle"
                                style={{ margin: "-16px" }}
                                classNames="btn-background-orange"
                                onClick={() => {
                                    setAddNew(false);
                                }}
                            >
                                <CloseOutlined />
                            </EqButton>
                        }
                        width={1000}
                        onClose={onProductDrawerClose}
                        open={addNew || isEdit}
                        loading={false}
                    >
                        {/* <EqButton
                shape="circle"
                style={{ margin: "-16px" }}
                classNames="btn-background-orange"
                onClick={()=>{setAddNew(false)}}
            >
                <CloseOutlined />
            </EqButton> */}
                        <Tabs activeKey={activeTab} onChange={setActiveTab}>
                            {/* create/update tab *********************************************************************************/}
                            <Tabs.TabPane tab={isEdit ? t("update") : t("create")} key="tab1">
                                <Row justify="end">
                                    {isEdit && (
                                        <EditorCreateProduct
                                            isEdit={isEdit}
                                            product={selectedProduct}
                                            onEdit={handleOnEdit}
                                            onCancel={cancelEdit}
                                            onCreate={handleOnCreate}
                                        />
                                    )}

                                    {addNew && (
                                        <EditorCreateProduct
                                            onCreate={handleOnCreate}
                                            onCancel={cancelFunc}
                                            isEdit={false}
                                            product={undefined}
                                            onEdit={function (product: EqEntityProductDto): void {
                                                throw new Error("Function not implemented.");
                                            }}
                                        />
                                    )}
                                </Row>
                            </Tabs.TabPane>
                            {selectedProduct && (
                                <>
                                    {/* Orders tab ************************************************************************************/}
                                    <Tabs.TabPane tab={t("orders")} key="tab2">
                                        <div className="product-order-details">
                                            {/* filter */}
                                            <Row className="filter-row">
                                                <Col span={24} className="filters">
                                                    <Row gutter={[16, 16]} className="filter-type">
                                                        <Col
                                                            className="location-col"
                                                            xs={24}
                                                            sm={24}
                                                            md={12}
                                                            lg={11}
                                                        >
                                                            <Row className="location-selector">
                                                                <Col xs={6} sm={5} md={6} lg={5}>
                                                                    <label className="picker-label">
                                                                        {t("student")}
                                                                    </label>
                                                                </Col>
                                                                <Col
                                                                    className="location-input"
                                                                    flex="auto"
                                                                >
                                                                    <Search
                                                                        placeholder={t(
                                                                            "searchNameMail"
                                                                        )}
                                                                        onChange={(e: any) =>
                                                                            searchNameClick(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>

                                            <EqProductsBoardOrderList
                                                products={filterProductsOrders([selectedProduct])}
                                            />
                                        </div>
                                    </Tabs.TabPane>

                                    {/* invitations tab ***********************************************************************************/}

                                    {selectedProduct.type == EqProductType.Private && (
                                        <Tabs.TabPane tab={t("invitations")} key="tab3">
                                            <ProductInviteWidget
                                                data={productInvites}
                                                onDelete={handleDeleteProductInvite}
                                                onDeleteMultiple={handleDeleteProductInvites}
                                            />
                                        </Tabs.TabPane>
                                    )}
                                    {/* requests tab ******************************************************************************************/}
                                    {selectedProduct.type == EqProductType.Public && (
                                        <Tabs.TabPane tab={t("requests")} key="tab4">
                                            <RequestWidget
                                                // multipleSelect={true}
                                                data={productRequests}
                                                onAccept={(requestId: any) => {
                                                    handleAcceptProductRequest(requestId, null);
                                                }}
                                                OnReject={handleRejectProductRequest}
                                                OnAcceptMultiple={
                                                    handleAcceptProductMultipleRequests
                                                }
                                                OnRejectMultiple={
                                                    handleRejectProductMultipleRequests
                                                }
                                            />
                                        </Tabs.TabPane>
                                    )}
                                </>
                            )}
                        </Tabs>
                    </Drawer>

                    <div className="product-order-details">
                        <EqCollapsePanel
                            defaultOpen={false}
                            header={<div className="">{t("productOrderDetails")}</div>}
                        >
                            {/* filter */}
                            <Row className="filter-row">
                                <Col span={24} className="filters">
                                    {/* <div className="filters"> */}
                                    <Row gutter={[16, 16]} className="filter-type">
                                        <Col
                                            className="location-col"
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={11}
                                        >
                                            <Row className="location-selector">
                                                <Col xs={6} sm={5} md={6} lg={5}>
                                                    <label className="picker-label">
                                                        {t("student")}
                                                    </label>
                                                </Col>
                                                <Col className="location-input" flex="auto">
                                                    <Search
                                                        placeholder={t("searchNameMail")}
                                                        onChange={(e: any) =>
                                                            searchNameClick(e.target.value)
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col className="radius-col" xs={24} sm={24} md={12} lg={11}>
                                            <Row className="radius-selector">
                                                <Col xs={6} sm={5} md={6} lg={5}>
                                                    <label className="picker-label">
                                                        {t("product")}
                                                    </label>
                                                </Col>
                                                <Col className="radius-input" flex="auto">
                                                    <EqSelect {...productProps}></EqSelect>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col className="date-col " xs={24} sm={24} md={12} lg={11}>
                                            <Row className="date-selector  start-date-selector">
                                                <Col xs={6} sm={5} md={6} lg={5}>
                                                    <label className="picker-label">
                                                        {t("type")}
                                                    </label>
                                                </Col>
                                                <Col className="date-input" flex="auto">
                                                    <EqSelect {...productTypeProps}></EqSelect>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col className="search-col" xs={24} sm={24} md={12} lg={11}>
                                            <div className="search">
                                                <EqButton
                                                    classNames="eq-input-info"
                                                    type="primary"
                                                    htmlType="button"
                                                >
                                                    {t("search")}
                                                </EqButton>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <EqProductsBoardOrderList
                                products={filterProductsOrders(productsList.filteredList)}
                            />
                        </EqCollapsePanel>
                    </div>
                </div>
            </div>
        </AnimationDiv>
    );
};
export default EqOwnerProductsBoard;
